"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatusCard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_2 = require("@sierralabs/core");
const core_ui_1 = require("@sierralabs/core-ui");
const TaskAuditLogList_1 = __importDefault(require("../components/TaskAuditLogList"));
const TaskStatusLabel_1 = __importDefault(require("../components/TaskStatusLabel"));
const useFindTaskStatusLogs_1 = require("../hooks/useFindTaskStatusLogs");
const useParseTaskStatus_1 = require("../hooks/useParseTaskStatus");
const Task_event_1 = require("../Task.event");
const StyledCard = (0, styled_components_1.default)(core_1.Card) `
  position: relative;
  .title {
    margin-top: 0;
    font-weight: 500;
  }
  .audit-log {
    position: absolute;
    top: 12px;
    right: 12px;
  }
`;
const TaskStatusCard = props => {
    const { task, cardProps } = props;
    const limit = 5;
    const taskRef = (0, react_1.useRef)(task);
    const [page, setPage] = (0, react_1.useState)(0);
    const [logs, setLogs] = (0, react_1.useState)([]);
    const [showAuditLog, setShowAuditLog] = (0, react_1.useState)(false);
    const status = (0, useParseTaskStatus_1.useParseTaskStatus)(task.status) || 'N/A';
    const { statusLogList, isLoading, error, findStatusLogs } = (0, useFindTaskStatusLogs_1.useFindTaskStatusLogs)(task.id);
    const findStatusLogsWithParams = (0, react_1.useCallback)(() => {
        findStatusLogs({ page, limit });
    }, [page, limit, findStatusLogs]);
    const refresh = (0, react_1.useCallback)(() => {
        setLogs([]);
        // update page to 0, fetch if currently 0
        setPage(page => {
            page === 0 && findStatusLogsWithParams();
            return 0;
        });
    }, [findStatusLogsWithParams]);
    (0, react_1.useEffect)(() => {
        findStatusLogsWithParams();
    }, [findStatusLogsWithParams]);
    (0, react_1.useEffect)(() => {
        if (task !== taskRef.current) {
            taskRef.current = task;
            refresh();
        }
    }, [task, refresh]);
    // refresh on change status
    (0, react_1.useEffect)(() => {
        return Task_event_1.TaskEvent.handle(Task_event_1.TaskEventType.ChangeStatus, () => refresh());
    }, [refresh]);
    (0, react_1.useEffect)(() => {
        if (!(statusLogList === null || statusLogList === void 0 ? void 0 : statusLogList.data)) {
            return;
        }
        setLogs(logs => {
            if (statusLogList.page === 0) {
                logs = [];
            }
            const newLogs = statusLogList.data.filter(newLog => !logs.some(log => log.id === newLog.id));
            // sort the list after appending statuses
            return logs.concat(newLogs).sort((a, b) => {
                return new Date(b.created).getTime() - new Date(a.created).getTime();
            });
        });
    }, [statusLogList]);
    return (react_1.default.createElement(StyledCard, Object.assign({}, cardProps),
        react_1.default.createElement(core_ui_1.CardContent, { background: 'primary' },
            react_1.default.createElement(core_1.Typography, { variant: 'overline', style: { margin: 0, paddingTop: '20px' } }, "Status"),
            react_1.default.createElement(core_1.Typography, { variant: 'h4', className: 'title' }, status),
            react_1.default.createElement(core_1.Tooltip, { arrow: true, placement: 'left', title: showAuditLog ? 'Show Status Logs' : 'Show Audit Logs' },
                react_1.default.createElement(core_1.IconButton, { size: 'small', color: 'secondary', className: 'audit-log', onClick: () => setShowAuditLog(!showAuditLog) },
                    react_1.default.createElement(icons_1.History, null)))),
        showAuditLog ? (react_1.default.createElement(TaskAuditLogList_1.default, { task: task })) : (react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null, "History"),
                        react_1.default.createElement(core_1.TableCell, null, "Status"),
                        react_1.default.createElement(core_1.TableCell, null, "Employee"))),
                react_1.default.createElement(core_1.TableBody, null,
                    isLoading && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 3, padding: 'none' },
                            react_1.default.createElement(core_1.LinearProgress, null)))),
                    error && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 3, padding: 'none' },
                            react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)))), logs === null || logs === void 0 ? void 0 :
                    logs.map(log => (react_1.default.createElement(core_1.TableRow, { key: log.id },
                        react_1.default.createElement(core_1.TableCell, null, (0, core_2.formatDate)(log.created)),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(TaskStatusLabel_1.default, { task: task, status: log.status })),
                        react_1.default.createElement(core_1.TableCell, null,
                            log.createdBy.firstName,
                            " ",
                            log.createdBy.lastName)))))))),
        statusLogList && statusLogList.total > (page + 1) * limit && (react_1.default.createElement(core_1.Box, { padding: 2, textAlign: 'center' },
            react_1.default.createElement(core_1.Link, { variant: 'body2', component: 'button', onClick: () => setPage(page + 1) }, "Load More")))));
};
exports.TaskStatusCard = TaskStatusCard;
exports.default = exports.TaskStatusCard;
//# sourceMappingURL=TaskStatusCard.js.map